// extracted by mini-css-extract-plugin
export var container = "_62-0";
export var error = "_62-9";
export var label = "_62-5";
export var light = "_62-6";
export var md = "_62-3";
export var sm = "_62-2";
export var thin = "_62-8";
export var thinBold = "_62-7";
export var vertical = "_62-4";
export var xs = "_62-1";